module.exports = __webpack_public_path__ + "media/pages/assets/images/blank-square-efd8e2577bd104837ebaa0e613587187.png";